export default class CreateMarkerTypeModel {
    organizationId = null;
    label = null;
    description = null;
    color = null;
    shape = null;

    constructor(organizationId, label, description, color = null, shape = null){
        this.organizationId = organizationId;
        this.label = label;
        this.description = description;
        this.color = color;
        this.shape = shape;
    }
}
